import React, { useState } from 'react';
import { auth } from './firebase';
import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';
import tutorImg from './tutor.png';

const NAVY        = '#112A46';
const ORANGE      = '#F26B3A';
const ORANGE_DARK = '#d95a28';

export default function Auth() {
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail]           = useState('');
  const [password, setPassword]     = useState('');
  const [error, setError]           = useState('');
  const [acceptedTerms, setAcceptedTerms] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!isLogin && !acceptedTerms) {
      setError('חובה לאשר את תנאי השימוש ומדיניות הפרטיות כדי להירשם.');
      return;
    }
    try {
      if (isLogin) {
        await signInWithEmailAndPassword(auth, email, password);
      } else {
        await createUserWithEmailAndPassword(auth, email, password);
      }
    } catch (err) {
      setError('שגיאה: ' + err.message);
    }
  };

  return (
    <div
      dir="rtl"
      style={{
        minHeight: '100vh',
        width: '100%',
        background: '#F4F7F9',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: "'Heebo', Arial, sans-serif",
        padding: '20px',
      }}
    >
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Heebo:wght@400;500;600;700;800;900&display=swap');
        *, *::before, *::after { box-sizing: border-box; }
        body { margin: 0; padding: 0; }

        .a-input {
          width: 100%;
          padding: 15px 18px;
          border-radius: 12px;
          border: 1.5px solid #e2e8f0;
          font-size: 15px;
          color: ${NAVY};
          background: #f9fafb;
          outline: none;
          direction: ltr;
          text-align: left;
          font-family: inherit;
          transition: border-color .2s, box-shadow .2s, background .2s;
        }
        .a-input::placeholder { color: #b0bec8; }
        .a-input:focus {
          border-color: ${NAVY};
          background: #fff;
          box-shadow: 0 0 0 4px rgba(17,42,70,.08);
        }

        .a-btn {
          width: 100%;
          padding: 16px;
          background: ${ORANGE};
          color: #fff;
          border: none;
          border-radius: 13px;
          font-size: 16px;
          font-weight: 800;
          font-family: inherit;
          cursor: pointer;
          box-shadow: 0 6px 22px rgba(242,107,58,.32);
          transition: transform .2s, box-shadow .2s, background .2s;
          letter-spacing: .2px;
        }
        .a-btn:hover {
          background: ${ORANGE_DARK};
          transform: translateY(-2px);
          box-shadow: 0 12px 30px rgba(242,107,58,.42);
        }
        .a-btn:active { transform: translateY(0); }

        .a-tab {
          flex: 1;
          padding: 11px 0;
          background: transparent;
          border: none;
          font-size: 14.5px;
          font-family: inherit;
          font-weight: 600;
          cursor: pointer;
          transition: color .2s;
          border-bottom: 2.5px solid transparent;
        }

        .a-social {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 7px;
          padding: 11px 14px;
          border-radius: 11px;
          text-decoration: none;
          font-size: 13px;
          font-weight: 700;
          font-family: inherit;
          transition: transform .2s, box-shadow .2s;
        }
        .a-social:hover { transform: translateY(-2px); box-shadow: 0 6px 18px rgba(0,0,0,.10); }

        .a-toggle:hover { opacity: .75; }
      `}</style>

      {/* ── Floating card ── */}
      <div
        style={{
          width: '90%',
          maxWidth: 450,
          background: '#ffffff',
          borderRadius: 24,
          padding: '50px 48px 44px',
          boxShadow: '0 20px 60px rgba(17,42,70,.10), 0 4px 18px rgba(17,42,70,.05)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >

        {/* ── Tutor image ── */}
        <div
          style={{
            width: 110,
            height: 110,
            borderRadius: '50%',
            overflow: 'hidden',
            border: `3.5px solid ${ORANGE}`,
            boxShadow: `0 6px 24px rgba(242,107,58,.28), 0 0 0 6px rgba(242,107,58,.08)`,
            marginBottom: 18,
            flexShrink: 0,
          }}
        >
          <img
            src={tutorImg}
            alt="טל ספו"
            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
          />
        </div>

        {/* ── Title ── */}
        <h1
          style={{
            margin: '0 0 28px',
            fontSize: 22,
            fontWeight: 900,
            color: NAVY,
            letterSpacing: '-0.4px',
            textAlign: 'center',
            lineHeight: 1.25,
          }}
        >
          טל מתחקרת פסיכומטרי
        </h1>

        {/* ── Tabs ── */}
        <div
          style={{
            display: 'flex',
            width: '100%',
            borderBottom: '2px solid #f0f2f5',
            marginBottom: 28,
          }}
        >
          {[{ label: 'התחברות', val: true }, { label: 'הרשמה', val: false }].map(({ label, val }) => (
            <button
              key={label}
              className="a-tab"
              onClick={() => setIsLogin(val)}
              style={{
                color: isLogin === val ? ORANGE : '#94a3b8',
                borderBottom: `2.5px solid ${isLogin === val ? ORANGE : 'transparent'}`,
                fontWeight: isLogin === val ? 800 : 600,
              }}
            >
              {label}
            </button>
          ))}
        </div>

        {/* ── Form ── */}
        <form
          onSubmit={handleSubmit}
          style={{ display: 'flex', flexDirection: 'column', gap: 16, width: '100%' }}
        >
          <div>
            <label style={{ display: 'block', fontSize: 12.5, fontWeight: 700, color: NAVY, marginBottom: 7 }}>
              כתובת אימייל
            </label>
            <input
              className="a-input"
              type="email"
              placeholder="your@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div>
            <label style={{ display: 'block', fontSize: 12.5, fontWeight: 700, color: NAVY, marginBottom: 7 }}>
              סיסמה
            </label>
            <input
              className="a-input"
              type="password"
              placeholder="לפחות 6 תווים"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {error && (
            <div
              style={{
                background: '#fff4f0',
                border: '1.5px solid #fbc9b3',
                borderRadius: 10,
                padding: '11px 14px',
                fontSize: 13,
                color: '#b83c00',
                fontWeight: 500,
                display: 'flex',
                alignItems: 'center',
                gap: 8,
              }}
            >
              <span style={{ flexShrink: 0 }}>⚠️</span>
              <span>{error}</span>
            </div>
          )}

          {!isLogin && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                marginBottom: 16,
                direction: 'rtl',
              }}
            >
              <input
                id="terms-checkbox"
                type="checkbox"
                checked={acceptedTerms}
                onChange={(e) => setAcceptedTerms(e.target.checked)}
                style={{
                  width: 17,
                  height: 17,
                  accentColor: ORANGE,
                  cursor: 'pointer',
                  flexShrink: 0,
                }}
              />
              <label
                htmlFor="terms-checkbox"
                style={{ fontSize: 14, color: '#6b7280', cursor: 'pointer', userSelect: 'none', lineHeight: 1.5 }}
              >
                קראתי ואני מסכים/ה ל-
                <a
                  href="https://elated-rib-b55.notion.site/323ec7161ac180b59b9eedc1283b83d7?pvs=73"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ fontWeight: 700, color: ORANGE, textDecoration: 'none' }}
                >
                  תנאי השימוש ומדיניות הפרטיות
                </a>
              </label>
            </div>
          )}

          <button className="a-btn" type="submit" style={{ marginTop: 4 }}>
            {isLogin ? 'כניסה למערכת' : 'יצירת חשבון'}
          </button>
        </form>

        {/* ── Toggle ── */}
        <p style={{ margin: '18px 0 0', fontSize: 13.5, color: '#7a8fa6', textAlign: 'center' }}>
          {isLogin ? 'אין לך חשבון עדיין? ' : 'כבר יש לך חשבון? '}
          <button
            className="a-toggle"
            onClick={() => setIsLogin(!isLogin)}
            style={{
              background: 'none',
              border: 'none',
              fontSize: 13.5,
              color: ORANGE,
              fontWeight: 800,
              cursor: 'pointer',
              fontFamily: 'inherit',
              padding: 0,
              textDecoration: 'underline',
              textUnderlineOffset: 3,
              transition: 'opacity .2s',
            }}
          >
            {isLogin ? 'הירשמ/י כאן' : 'התחבר/י כאן'}
          </button>
        </p>

        {/* ── Divider ── */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            width: '100%',
            margin: '24px 0 18px',
          }}
        >
          <div style={{ flex: 1, height: 1, background: '#e5e7eb' }} />
          <span
            style={{
              fontSize: 11.5,
              color: '#c0cad4',
              fontWeight: 600,
              letterSpacing: '0.5px',
              whiteSpace: 'nowrap',
            }}
          >
            עקבו אחריי
          </span>
          <div style={{ flex: 1, height: 1, background: '#e5e7eb' }} />
        </div>

        {/* ── Social buttons ── */}
        <div style={{ display: 'flex', gap: 10, width: '100%' }}>

          {/* Instagram */}
          <a
            href="https://www.instagram.com/talsapo_psycho?igsh=MWRyb2czZDJ5MmJycg=="
            target="_blank"
            rel="noopener noreferrer"
            className="a-social"
            style={{
              background: 'linear-gradient(135deg,#fff0fa,#fff7f2)',
              border: '1.5px solid #f0d5ec',
              color: '#a0259e',
              boxShadow: '0 2px 8px rgba(160,37,158,.07)',
            }}
          >
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none">
              <defs>
                <linearGradient id="ig-card" x1="0%" y1="100%" x2="100%" y2="0%">
                  <stop offset="0%"   stopColor="#f09433" />
                  <stop offset="45%"  stopColor="#dc2743" />
                  <stop offset="100%" stopColor="#bc1888" />
                </linearGradient>
              </defs>
              <rect x="2" y="2" width="20" height="20" rx="5.5" fill="url(#ig-card)" />
              <circle cx="12" cy="12" r="4.5" fill="none" stroke="#fff" strokeWidth="1.7" />
              <circle cx="17.5" cy="6.5" r="1.2" fill="#fff" />
            </svg>
            Instagram
          </a>

          {/* TikTok */}
          <a
            href="https://www.tiktok.com/@talsapo?_r=1&_t=ZS-94dhay2oDcO"
            target="_blank"
            rel="noopener noreferrer"
            className="a-social"
            style={{
              background: '#f5f5f6',
              border: '1.5px solid #e2e4e7',
              color: '#111',
              boxShadow: '0 2px 8px rgba(0,0,0,.05)',
            }}
          >
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none">
              <rect width="24" height="24" rx="6" fill="#010101" />
              <path
                d="M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 0 1-2.59 2.5 2.59 2.59 0 0 1-2.59-2.59 2.59 2.59 0 0 1 2.59-2.59c.25 0 .49.04.72.1V9.62a5.69 5.69 0 0 0-.72-.04 5.68 5.68 0 0 0-5.68 5.68 5.68 5.68 0 0 0 5.68 5.68 5.68 5.68 0 0 0 5.68-5.68V9.19a7.35 7.35 0 0 0 4.3 1.38V7.48s-1.88.1-3.24-1.66Z"
                fill="#fff"
              />
            </svg>
            TikTok
          </a>

        </div>
      </div>
    </div>
  );
}
